var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertIconCertificateIconAltBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "38px",
    viewBox: "0 0 30 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "course-1-details",
    transform: "translate(-271.000000, -210.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cert-icon",
    transform: "translate(271.854545, 211.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFD157"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "7.15775493 18 18.7636364 20.1266285 12.5440632 36 7.6740585 32.55568 0.938181818 33.8733715"
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(19.232727, 27.000000) scale(-1, 1) translate(-19.232727, -27.000000) ",
    points: "16.5395731 18 28.1454545 20.1266285 21.9258814 36 17.0558767 32.55568 10.32 33.8733715"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star",
    points: "14.0727273 26.3212597 11.8712677 28.2460975 10.366595 25.7285182 7.68384279 26.872198 7.02324478 24.0083154 4.12180639 24.2588858 4.36994702 21.3290368 1.53383546 20.6619703 2.666425 17.9529487 0.173258625 16.4335424 2.07943131 14.2105263 0.173258625 11.9875102 2.666425 10.4681039 1.53383546 7.75908237 4.36994702 7.09201584 4.12180639 4.16216679 7.02324478 4.4127372 7.68384279 1.54885466 10.366595 2.69253442 11.8712677 0.17495516 14.0727273 2.09979294 16.2741868 0.17495516 17.7788595 2.69253442 20.4616118 1.54885466 21.1222098 4.4127372 24.0236482 4.16216679 23.7755075 7.09201584 26.6116191 7.75908237 25.4790295 10.4681039 27.9721959 11.9875102 26.0660232 14.2105263 27.9721959 16.4335424 25.4790295 17.9529487 26.6116191 20.6619703 23.7755075 21.3290368 24.0236482 24.2588858 21.1222098 24.0083154 20.4616118 26.872198 17.7788595 25.7285182 16.2741868 28.2460975"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.0727273,
    cy: 14.2105263,
    rx: 6.06727273,
    ry: 6.13157895
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertIconCertificateIconAltBig);
export default __webpack_public_path__ + "static/media/cert_icon-certificate_icon_alt_big.18bbb9223c896c9da1a048d2cadacc76.svg";
export { ForwardRef as ReactComponent };